<template>
    <a
        class="nav-child flex items-center border-b last:border-b-0 no-underline hover:no-underline whitespace-nowrap p-4 pr-8 first:rounded-t last:rounded-b"
        :class="{
            active: active,
        }"
        :rel="external ? 'noopener' : ''"
        :href="path"
        :target="target"
    >
        <div
            class="nav-child-icon flex items-center justify-center rounded w-8 h-8"
        >
            <SvgIcon :icon="icon" size="base" />
        </div>
        <div class="nav-child-label tracking-tight ml-3">
            {{ label }}
        </div>
    </a>
</template>

<script lang="ts">
import { mapGetters } from "vuex";

export default {
    props: {
        admin: Boolean,
        external: Boolean,
        icon: String,
        label: String,
        path: {
            type: String,
            default: "#",
        },
    },
    computed: {
        ...mapGetters(["appPath"]),
        active() {
            return window.location.href.indexOf(this.path) > -1;
            return this.appPath.indexOf(this.path) > -1;
        },
        target() {
            return this.external ? "_blank" : "_self";
        },
    },
};
</script>
